import { render, staticRenderFns } from "./EnrollExamSubjectSetting.vue?vue&type=template&id=3fc31aa8"
import script from "./EnrollExamSubjectSetting.vue?vue&type=script&lang=js"
export * from "./EnrollExamSubjectSetting.vue?vue&type=script&lang=js"
import style0 from "./EnrollExamSubjectSetting.vue?vue&type=style&index=0&id=3fc31aa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports